var $orderButton,
    $buttonPrice,
    $buttonLabel;

$(document).ready(function ($) {
    $orderButton = $('.js-order-button a');
    $buttonPrice = $('.js-price-target');
    $buttonLabel = $('.js-button-label');

    setTimeoutInSale();

    function setTimeoutInSale() {
      const date_sale = $orderButton.attr('data-insale');

      if (typeof date_sale === 'undefined' || !date_sale) {
        return;
      }
      const insaleDate = new Date(date_sale);
      const now = new Date();
      
      if (isNaN(insaleDate)) {
          console.warn('Ongeldige datum meegegeven:', date_sale);
          return;
      }
      
      // Verschil in milliseconden
      const diffMs = insaleDate - now;
      
      if (diffMs > 2147483647) {
          console.warn('Tijd te ver in de toekomst voor setTimeout');
          return;
      }
      
      if (diffMs > 0) {
          // Datum ligt in de toekomst
          setTimeout(() => {
              switchToInSale();
          }, diffMs); 
      } else {
          // Datum ligt in het verleden of is nu
          switchToInSale();
      }
    }

    function switchToInSale() {
        $orderButton.toggleClass('is-updating');
        setTimeout(function() {
            var label = $buttonLabel.attr('data-state');
            $buttonLabel.html(label);
            $buttonPrice.removeClass('is-hidden');
            $orderButton.removeClass('is-updating');
            $orderButton.removeClass('is-disabled');
        }, 500);
    }
});
